/**
 * Copyright (c) 2024 rports (r), All rights reserved.
 *
 *     ______    _______  _______  ______    _______  _______ 
 *    |    _ |  |       ||       ||    _ |  |       ||       |
 *    |   | ||  |    _  ||   _   ||   | ||  |_     _||  _____|
 *    |   |_||_ |   |_| ||  | |  ||   |_||_   |   |  | |_____ 
 *    |    __  ||    ___||  |_|  ||    __  |  |   |  |_____  |
 *    |   |  | ||   |    |       ||   |  | |  |   |   _____| |
 *    |___|  |_||___|    |_______||___|  |_|  |___|  |_______|
 *
 * filename      : Contact.jsx
 * description   : {{insert here}}
 * creation date : 26/02/2024
 * author        : "Luis CRUZ" <luis.cruz@rports.net>
 */



// --------------------------------------------------------------------------------
//      IMPORTS
// --------------------------------------------------------------------------------

import {
    Fragment,
} from 'react';

import {
    useComponentContext,
} from '@/components/core';

import {
    ViewPortContainer,
} from '@/components/snippets/CustomDiv';

import {
    ContentContainer,
} from '@/components/snippets/ContentDiv';

import {
    config_page_HOME_contact as page_configuration,
} from '@/components/layouts/core';

import ContactForm from '@/components/ContactForm';



// --------------------------------------------------------------------------------
//      FUNCTIONS
// --------------------------------------------------------------------------------

function Contact({ id }) {
    // Component context
    const { ctx } = useComponentContext();

    // Detect private access
    if (false === ctx.api.location.canBeDisplayed(page_configuration)) {
        return null;
    }

    return (
        <Fragment>
            <ContentContainer
                rightAligned={false}
                id={id}
                title='Contact' // TODO: Translate message
            >
                <ViewPortContainer>
                    <ContactForm />
                </ViewPortContainer>
            </ContentContainer>
        </Fragment>
    );
}



// --------------------------------------------------------------------------------
//      EXPORTED OBJECTS
// --------------------------------------------------------------------------------

export default Contact;



// End of file
